import last from 'lodash/last';
import camelCase from 'lodash/camelCase';
import { createServiceError } from './serverErrorFormatter';

var getValidationErrors = function getValidationErrors(error) {
  var serviceError = createServiceError(error);

  if (!serviceError.message && !serviceError.details) {
    return undefined;
  }

  try {
    var parsedMessage = serviceError.details || JSON.parse(serviceError.message);
    var validationErrors = parsedMessage === null || parsedMessage === void 0 ? void 0 : parsedMessage.validationErrors;

    if (validationErrors) {
      var res = Object.keys(validationErrors).reduce(function (errors, key) {
        var keyParts = key.split('.');
        var errorKey = last(keyParts) || key;
        errors[camelCase(errorKey)] = validationErrors[key][0];
        return errors;
      }, {});
      return res;
    }

    return undefined;
  } catch (_a) {
    return undefined;
  }
};

export default getValidationErrors;